import React, { Component } from 'react';
import { Card, Table, Col } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { obtenerCola } from "../actions/index";
import { connect } from 'react-redux';
//12 Turnos caben

const mapStateToProps = state => {
    return {
        colaActual: state.colaPantalla,
        //roles: state.rol,
        //servicios: state.servicios
    };
};

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators({ obtenerCola }, dispatch)
    };
};

class TablaPantalla extends Component {

    constructor(props) {
        super(props);
        this.state = {
            idCola: "",
            cola: [],
        };

        this.actualizarCola = this.actualizarCola.bind(this);
    }

    componentDidMount() {
        this.setState({
            idCola: this.props.idArea,
        })
        this.props.obtenerCola(this.props.idArea);
    }

    actualizarCola() {
        //Turno - Modulo - Piso - Estado

        var lista = this.props.colaActual.map(p => {
            return (
                <tr key={p.numero_turno}>
                    <th scope="row"><h2>{p.numeroTurno}</h2></th>
                    <td ><h2>{p.modulo}</h2></td>
                    <td ><h2>{p.estadoTurno}</h2></td>
                </tr>
            )
        })


        this.setState({
            cola: lista,
        })

        setTimeout(
            function () {
                this.props.obtenerCola(this.props.idArea);
            }
                .bind(this),
            5000
        );
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.colaPantalla !== [] && nextProps.colaPantalla !== this.props.colaActual) {
            setTimeout(
                function () {
                    this.actualizarCola();
                }
                    .bind(this),
                10
            );
        }
    }

    render() {
        return (
            <Col xs="12" style={{ height: "100%" }}>
                <Card style={{ height: "100%" }}>
                    <Table striped responsive >
                        <thead>
                            <tr>
                                <th>Turno</th>
                                <th>Módulo</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.cola}
                        </tbody>
                    </Table>
                </Card>
            </Col>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TablaPantalla);
